import styled from 'styled-components';

export const HelpIconWrapper = styled.span`
  svg {
    fill: #757575;
    font-size: 50px;
  }
`;

export const NoResultsTitle = styled.h2`
  font-size: 24px;
`;

export const NoResultsDescription = styled.h3`
  font-size: 18px;
`;
